import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  topicsSearch: "",
  topicsTable: {
    pagination: {
      current: 1,
      pageSize: 10,
    },
    filters: {},
    sorter: {},
  },
  subCategorySearch: "",
  subCategoryTable: {
    pagination: {
      current: 1,
      pageSize: 10,
    },
    filters: {},
    sorter: {},
  },
  subtopicsSearch: "",
  subtopicsTable: {
    pagination: {
      current: 1,
      pageSize: 10,
    },
    filters: {},
    sorter: {},
  },
  questionsSearch: "",
  questionsTable: {
    pagination: {
      current: 1,
      pageSize: 10,
    },
    filters: {},
    sorter: {},
  },
};

export const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    TopicsSearch: (state, action) => {
      state.topicsSearch = action.payload;
    },
    TopicsTable: (state, action) => {
      state.topicsTable = action.payload;
    },
    SubCategorySearch: (state, action) => {
      state.subCategorySearch = action.payload;
    },
    SubCategoryTable: (state, action) => {
      state.subCategoryTable = action.payload;
    },
    SubtopicsSearch: (state, action) => {
      state.subtopicsSearch = action.payload;
    },
    SubtopicsTable: (state, action) => {
      state.subtopicsTable = action.payload;
    },
    QuestionsSearch: (state, action) => {
      state.questionsSearch = action.payload;
    },
    QuestionsTable: (state, action) => {
      state.questionsTable = action.payload;
    },
  },
});

export const {
  TopicsSearch,
  TopicsTable,
  SubCategorySearch,
  SubCategoryTable,
  SubtopicsSearch,
  SubtopicsTable,
  QuestionsSearch,
  QuestionsTable,
} = tableSlice.actions;

export default tableSlice.reducer;
